import { Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

interface IAccountStatementRequestModalProps {
    email: string;
    isModalOpen: boolean;
    fromDateString: string;
    toDateString: string;
    canSubmitRequest: boolean;
    modalHeaderLabel: string;
    sendToEmailLabel: string;
    fromDateLabel: string;
    toDateLabel: string;
    submitRequestLabel: string;
    cancelLabel: string;
    toggle(): void;
    onChangeFromDate(newFromDate: string): void;
    onChangeToDate(newToDate: string): void;
}

export const RequestStatementModal: React.FC<IAccountStatementRequestModalProps> = ({ email, isModalOpen, toggle, fromDateString, toDateString, onChangeFromDate, onChangeToDate, canSubmitRequest,
        modalHeaderLabel, sendToEmailLabel, fromDateLabel, toDateLabel, submitRequestLabel, cancelLabel }) => {

    const onChangeFromDateEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        onChangeFromDate(value);
    };

    const onChangeToDateEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        onChangeToDate(value);
    };

    return (
    <Modal
        className='ms-account-customer-balance__requestStatement__modal'
        isOpen={isModalOpen}
        horizontalPosition={'center'}
        verticalPosition={'center'}
        autoFocus={true}
        fade={false}
        toggle={toggle}
    >
        <ModalHeader>{modalHeaderLabel}</ModalHeader>
        <ModalBody>
            <label htmlFor='sendToEmail'>{sendToEmailLabel}</label>
            <br />
            <div id='sendToEmail' className='ms-account-customer-balance__sendToEmail'>{email}</div>
            <div>
                <div className='ms-account-customer-balance__requestStatement__fromDate'>
                    <label htmlFor='fromDateSelector'>{fromDateLabel}</label>
                    <input id='fromDateSelector' type='date' value={fromDateString} onChange={onChangeFromDateEvent} max={toDateString} className='ms-account-customer-balance__dateSelector form-control'/>
                </div>
                <div className='ms-account-customer-balance__requestStatement__toDate'>
                    <label htmlFor='toDateSelector'>{toDateLabel}</label>
                    <input id='oDateSelector' type='date' value={toDateString} onChange={onChangeToDateEvent} min={fromDateString} className='ms-account-customer-balance__dateSelector form-control'/>
                </div>
            </div>
        </ModalBody>
        <ModalFooter>
            <button className='ms-account-customer-balance__action__submitRequest' onClick={toggle} disabled={!canSubmitRequest}>{submitRequestLabel}</button>{' '}
            <button className='ms-account-customer-balance__action__cancelRequest' onClick={toggle}>{cancelLabel}</button>
          </ModalFooter>
    </Modal>
    );
};